import { useMediaQuery } from '@material-ui/core';

/**
 * The credentials table needs roughly 1450-1600px, depending on whether the DE postal-code column
 * is shown. Below that it would scroll sideways, so the action buttons drop their labels and keep
 * only their icons instead. Tune this one value if the table still scrolls.
 */
export const COMPACT_ACTIONS_QUERY = '(max-width: 1600px)';

export const useCompactActions = () => useMediaQuery(COMPACT_ACTIONS_QUERY);
